import type { AirportMetar } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const airportsIdMetarGet = async (id: number) => {
    return coreRequestService<AirportMetar>({
        url: `/airports/${id}/metar`,
        method: 'GET'
    });
};
